import { useEffect, useState } from "react";
import { fetchOpcionesMenu } from "../../services/parameter.service";

const useNuevasOpciones = () => {

  const [opcionesMenuNuevas, setOpcionesMenuNuevas] = useState([]);

  const getNuevasOpciones = async () => {
    try {
      const response = await fetchOpcionesMenu({
        App: "SI",
        Publica: "SI",
        Tipo: "MENUNUEVASOPCIONES",
      });

      setOpcionesMenuNuevas(response.data.list);

    } catch (error) {
      console.error(" ERROR EN GET NUEVAS OPCIONES --> ", error);
    }
  };

  useEffect(() => {
    getNuevasOpciones();
  }, []);

  return {
    opcionesMenuNuevas
  };
};

export default useNuevasOpciones;
